(function () {
  var phoneNumber = '447479741255';
  var button = document.getElementById('whatsapp-float-button');
  if (!button) return;

  var path = window.location.pathname.toLowerCase();
  var url = window.location.origin + window.location.pathname;
  var message;

  if (path === '/' || path === '') {
    message = "Hi, I'd like to know more about Ice & Co Jewellers 👋";
  } else if (path.indexOf('/products/custom-product') !== -1) {
    message = "Hi, I'm interested in creating a custom piece. Here's the page I'm on: " + url;
  } else if (path.indexOf('/collections/') !== -1) {
    message = 'Hi, I have a question about this collection: ' + url;
  } else if (path.indexOf('/products/') !== -1) {
    message = 'Hi, I have a question about this product: ' + url;
  } else if (path.indexOf('appointment') !== -1) {
    message = "Hi, I'd like to book an appointment: " + url;
  } else if (path.indexOf('bridal') !== -1) {
    message = "Hi, I'm interested in a bridal ring: " + url;
  } else if (path.indexOf('contact') !== -1 || path.indexOf('about') !== -1) {
    message = "Hi, I'd like to get in touch: " + url;
  } else {
    message = 'Hi, I have a question: ' + url;
  }

  button.href = 'https://wa.me/' + phoneNumber + '?text=' + encodeURIComponent(message);
})();
